/* UmproTech Stage 15 — lightweight executive widget runtime. No external deps. */
(function () {
  'use strict';
  if (window.__umproStage15WidgetsLoaded) return;
  window.__umproStage15WidgetsLoaded = true;

  function updateChecklist(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ut15-check]'));
    var total = buttons.length || 1;
    var checked = buttons.filter(function (button) {
      return button.getAttribute('aria-pressed') === 'true';
    }).length;
    var pct = Math.round((checked / total) * 100);
    var bar = root.querySelector('[data-ut15-progress-fill]');
    var text = root.querySelector('[data-ut15-progress-text]');
    if (bar) bar.style.width = pct + '%';
    if (text) text.textContent = checked + '/' + total + ' buying details confirmed';
  }

  function bindChecklist(root) {
    if (!root || root.dataset.ut15Bound === 'true') return;
    root.dataset.ut15Bound = 'true';
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ut15-check]'));
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var next = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', next ? 'true' : 'false');
        updateChecklist(root);
      });
    });
    updateChecklist(root);
  }

  function init() {
    document.querySelectorAll('[data-ut15-checklist]').forEach(bindChecklist);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
